import { CommentType, CommentOrientation } from '@constants'
import { postRequest, patchRequest, deleteRequest } from '../utils'

export interface CommentCreateDTO {
  position: { x: number; y: number; z: number }
  text: string
  type: CommentType
  orientation: CommentOrientation
  color: string
  backgroundColor: string
  showTitle: boolean
  storeysForPlans: string[]
  showInPlans: {
    positionPlan: boolean
    stiffeningPlan: boolean
    loadPlan: boolean
  }
  callouts?: Array<{
    end: { x: number; y: number; z: number }
    knee: { x: number; y: number; z: number } | null
  }> | null
  storeyForSceneRendering?: string | null
  element_guid?: string | null
}

export interface CommentModifyDTO {
  position?: { x: number; y: number; z: number }
  text?: string
  type?: CommentType
  orientation: CommentOrientation
  color?: string
  backgroundColor?: string
  showTitle?: boolean
  storeysForPlans?: string[]
  showInPlans?: {
    positionPlan: boolean
    stiffeningPlan: boolean
    loadPlan: boolean
  }
  callouts?: Array<{
    end: { x: number; y: number; z: number }
    knee: { x: number; y: number; z: number } | null
  }> | null
  storeyForSceneRendering?: string | null
  element_guid?: string | null
}

export const createComment: RequestTypeVariable = {
  getKey: (projectGuid: string) => ['createComment', projectGuid],
  request: async (projectGuid: string, data: CommentCreateDTO): Promise<Comment3D[]> => {
    const { data: result } = await postRequest<Comment3D[]>({
      url: `/projects/${projectGuid}/comments`,
      data,
    })
    return result || []
  },
}

export const updateComment: RequestTypeVariable = {
  getKey: (projectGuid: string, commentId: string) => ['updateComment', projectGuid, commentId],
  request: async (
    projectGuid: string,
    commentId: string,
    data: CommentModifyDTO,
  ): Promise<Comment3D[]> => {
    const { data: result } = await patchRequest<Comment3D[]>({
      url: `/projects/${projectGuid}/comments/${commentId}`,
      data,
    })
    return result || []
  },
}

export const deleteComment: RequestTypeVariable = {
  getKey: (projectGuid: string, commentId: string) => ['deleteComment', projectGuid, commentId],
  request: async (projectGuid: string, commentId: string): Promise<Comment3D[]> => {
    const { data: result } = await deleteRequest<Comment3D[]>({
      url: `/projects/${projectGuid}/comments/${commentId}`,
    })
    return result || []
  },
}
